<template>
  <div class="grid grid-cols-12">
  <div class="col-span-3 p-8 pt-4 lg:p-12 lg:pt-8 lg:pl-14 bg-transaction-gradient space-y-12">
    <slot name="left"></slot>
  </div>
  <div class="col-span-9 p-8 pt-4 lg:p-12 lg:pt-8 lg:pr-17 grid grid-cols-2 col-gap-12 row-gap-12">
    <slot name="right"></slot>
  </div>
</div>
</template>

<script>
export default {
  name: "LeftGradientBlockLayoutBody"
}
</script>